/* global gsap, ScrollTrigger, ScrollSmoother, ScrollToPlugin, SplitText */

// Centralized function to set up all animations
const setupAnimations = () => {
    const globalWindow = /** @type {any} */ (window);
    const gsap = globalWindow.gsap;
    const ScrollTrigger = globalWindow.ScrollTrigger;
    const SplitText = globalWindow.SplitText;
    const screenWidth = window.innerWidth < 900;

    // Register plugins once
    if (gsap && ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.clearScrollMemory();
    } else {
        console.error("GSAP or ScrollTrigger not loaded. Animations skipped.");
        return;
    }


    // --- Header Animation Logic ---
const header = document.getElementById("site-header");
const screenInnerWidth = window.innerWidth

if (header && screenInnerWidth > 800) {
  const headerNav = header.querySelector(".header-nav");
  const logoImg = header.querySelector(".site-logo img");
  const headerAccount = header.querySelector('.header-account svg')
  const headerCart = header.querySelector('.header-cart svg')

  const easeSetting = "cubic-bezier(0.12, 0.23, 0.5, 1)";
  const animationDuration = 0.3;
  const threshold = 2;

  const getScroll = ScrollTrigger.getScrollFunc(window);
  let lastScroll = getScroll();
  let isDown = false;

  // Measure width carefully
  const initialHeaderWidth = header.offsetWidth;

  // 1. Create the master timeline
  const headerTl = gsap.timeline({
    paused: true,
    defaults: {
      duration: animationDuration,
      ease: easeSetting,
    },
    // 🔥 FIX: Use timeline-level callbacks for layout stability
    onStart: () => {
      if (headerNav) headerNav.style.position = "absolute";
    },
    onReverseComplete: () => {
      if (headerNav) {
        headerNav.style.position = "relative";
        // Force a layout repaint to prevent "ghost" shifts
        void headerNav.offsetWidth; 
      }
    }
  });

  // 2. Animate Background and Border Radius
  headerTl.to(header, {
    backgroundColor: "#dedede",
    borderRadius: "999px",
  }, 0);

  // 3. Animate Width
  headerTl.fromTo(header,
    { width: initialHeaderWidth },
    { width: 472.16 },
    0
  );

  // 4. Logo Filter
  if (logoImg) {
    headerTl.to(logoImg, { filter: "invert(1)" }, 0);
    headerTl.to(headerAccount, { filter: "invert(1)" }, 0);
    headerTl.to(headerCart, { filter: "invert(1)" }, 0);
  }

  // 5. Navigation Visibility (Layout is now handled by timeline callbacks above)
  if (headerNav) {
    headerTl.to(headerNav, {
      autoAlpha: 0,
      pointerEvents: "none",
    }, 0);
  }

  // 6. Scroll Trigger Controller
  ScrollTrigger.create({
    start: 0,
    end: () => ScrollTrigger.maxScroll(window),
    onUpdate() {
      const current = getScroll();
      const delta = current - lastScroll;

      // Ignore bounces at the top
      if (current <= threshold) {
        if (isDown) {
          headerTl.reverse();
          isDown = false;
        }
        lastScroll = current;
        return;
      }

      // SCROLL DOWN: Collapse
      if (delta >= threshold && !isDown) {
        headerTl.play();
        isDown = true;
      }
      // SCROLL UP: Expand
      else if (delta <= -threshold && isDown) {
        headerTl.reverse();
        isDown = false;
      }

      lastScroll = current;
    },
  });
}

    // --- Scroll-Based Animations (Original Code) ---
    // ... [Your existing ScrollTrigger animations here] ...
    
    // .intro-bg animation
    gsap.fromTo(
      ".intro-bg",
      {
        rotate: 90,
        yPercent: -68,
      },
      {
        rotate: 15,
        yPercent: 68,
        ease: "power1.out",
        scrollTrigger: {
          trigger: ".intro-subtitle",
          start: screenWidth ? "top center+=100" : "top bottom",
          end: screenWidth ? "top top" : "top 30%",
          scrub: 1.2,
        },
      }
    );

    // Budle scroll In animation (Bundles Card Left)
    gsap.fromTo(
      ".bundles-card-left img",
      {
        scale: 1.1,
      },
      {
        scale: 1,
        ease: "spring(0.5, 0.6, 1, 0)",
        scrollTrigger: {
          trigger: ".bundles-card-left",
          start: "top bottom",
          end: "top center",
          scrub: 1.2,
        },
      }
    );

    // Subscribe BG animation
    gsap.fromTo(
      ".subscribe-bg img",
      {
        scale: 1.1,
      },
      {
        scale: 1,
        ease: "spring(0.5, 0.6, 1, 0)",
        scrollTrigger: {
          trigger: ".subscribe-bg",
          start: "top bottom",
          end: "top top",
          scrub: 1.2,
        },
      }
    );

    // Best Sellers Card Image animation
    gsap.fromTo(
      ".best-sellers-card-image",
      {
        scale: 1.1,
      },
      {
        scale: 1,
        ease: "spring(0.5, 0.6, 1, 0)",
        duration: 1.2,
        scrollTrigger: {
          trigger: ".best-sellers-grid",
          start: "top bottom",
          end: "top center",
        },
      }
    );

    // About Split Image animation
    gsap.fromTo(
      ".about-split-image img",
      {
        scale: 1.1,
      },
      {
        scale: 1,
        ease: "spring(0.5, 0.6, 1, 0)",
        duration: 1.2,
        scrollTrigger: {
          trigger: ".about-split-container",
          start: "top 90%",
          end: "top 20%",
          scrub: true,
        },
      }
    );

    // Hover animation (kept as is, no scroll trigger dependency)
    document.querySelectorAll(".best-sellers-card").forEach((card) => {
      const img = card.querySelector(".best-sellers-card-image");

      card.addEventListener("mouseenter", () => {
        gsap.to(img, {
          scale: 1.1,
          duration: 0.4,
          ease: "spring(0.5, 0.6, 1, 0)",
        });
      });

      card.addEventListener("mouseleave", () => {
        gsap.to(img, {
          scale: 1,
          duration: 0.4,
          ease: "spring(0.5, 0.6, 1, 0)",
        });
      });
    });

    // --- Sticky Card Scale Animation ---
    const cards = document.querySelectorAll(".sticky-card");

   cards.forEach((card, i) => {
  if (i === cards.length - 1) return;

  const nextCard = cards[i + 1];

  gsap.fromTo(
    card,
    { scale: 1 },
    {
      scale: 0.95,
      ease: "none",
      scrollTrigger: {
        trigger: nextCard,
        start: "top 80%",
        end: "top 20%",
        scrub: true,
      }
    }
  );
});
    // --- Floating Image Pin/Scroll Animation ---
    const container = document.querySelector(".floating-image-container");

    if (container && container.children.length) {
      const images = container.querySelectorAll("img");

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".marquee-gallery-section",
          start: "top top",
          end: "+=1000",
          scrub: 1.5,
          pin: true,
          // FIX: pinSpacing should be set to true (default) or 'false' if explicitly handled by CSS
        },
      });

      // Floating image animation (retained logic)
      tl.to(
        images[0],
        { x: screenWidth ? "-90vw" :"-31vw", y: "-31vh", duration: 1, ease: "power2.inOut", scale: 0.4 },
        0
      );
      tl.to(
        images[1],
        { x: screenWidth ? "90vw" : "22vw", y: "-30vh", duration: 1, ease: "power2.inOut", scale: 0.4 },
        0
      );
      tl.to(
        images[2],
        {
          y: "-30vh",
          x: screenWidth ? "-90vw" : "-22vw",
          duration: 1,
          ease: "power2.inOut",
          scale: 0.35,
        },
        0
      );
      tl.to(
        images[3],
        { x: screenWidth ? "90vw" : "31vw", y: "-38vh", duration: 1, ease: "power2.inOut", scale: 0.35 },
        0
      );

      // Fade-in + scale animations for heading, text, marquee, button
      tl.fromTo(
        ".marquee-gallery-header, .marquee-gallery-description, .marquee-wrapper, .marquee-cta-button",
        { opacity: 0, scale: 0.95 },
        { opacity: 1, scale: 1, duration: 2, delay: 1, ease: "power2.out" },
        0
      );
    }

    const introTitle = document.querySelector(".intro-title");

    if (introTitle && SplitText) {
      // Split into lines and characters
      const split = new SplitText(introTitle, { type: "lines, chars" });

      // Each line is a wrapper <div>, containing chars
      const lines = split.lines;

      // Set initial state for all characters
      gsap.set(split.chars, {
        y: 20,
        opacity: 0,
        filter: "blur(2px)",
      });

      // Animate each line individually
      lines.forEach((line) => {
        gsap.to(line.children, {
          y: 0,
          opacity: 1,
          filter: "blur(0px)",
          duration: 0.6,
          ease: "power2.out",
          stagger: 0.05,

          scrollTrigger: {
            trigger: introTitle,
            start: "top 85%",
            toggleActions: "play none none none",
          },
        });
      });
    }

    // Bundle Animation
    // const bundleHeader = document.querySelector(".bundles-header");
    // const bundleTitle = document.querySelector(".bundles-title");
    // const bundleDescription = document.querySelector(".bundles-description");

    // gsap.fromTo(
    //   [bundleTitle, bundleDescription],
    //   {
    //     opacity: 0,
    //     y: 10,
    //   },
    //   {
    //     opacity: 1,
    //     y: 0,
    //     ease: "spring(0.5, 0.6, 1, 0)",
    //     duration: 0.6,
    //     scrollTrigger: {
    //       trigger: bundleHeader,
    //       start: "top 85%",
    //       toggleActions: "play none none none",
    //     },
    //   }
    // );

    animateHeroEntrance();
};


// ----------------------------------------------------
// 🔴 NEW FUNCTION: ISOLATED PRODUCT DETAIL ANIMATION
// This handles the elements that failed to load previously.
// ----------------------------------------------------
const animateProductDetails = () => {
    const gsap = (/** @type {any} */ (window)).gsap;
    if (!gsap) return;

    // Use querySelector *without* the parent class if the elements are top-level
    // and rely on the unique classes: .product-information__media and .product-details
    const productMedia = document.querySelector(".product-information__media");
    const productDetails = document.querySelector(".product-details");

    // CRITICAL CHECK: Log the result of the query
    console.log("Checking Product Media (animateProductDetails):", productMedia);
    console.log("Checking Product Details (animateProductDetails):", productDetails);

    if (!productMedia || !productDetails) {
        // If elements aren't found, try again later or wait for load event if necessary
        return; 
    }

    // Use a master timeline to control both animations simultaneously
    const loadTimeline = gsap.timeline({
        delay: 0.2,
        defaults: {
            duration: 1, 
            ease: "power2.out", 
            // NOTE: We don't set opacity: 1 here because the CSS sets the start,
            // but we must include it in the 'to' call if we use a timeline without an explicit 'from'
        }
    });

    // 1. Media Element Animation: Animate Y back to 0 (its natural position)
    loadTimeline.to(productMedia, {
        y: 0, // Moves from Y=100 (CSS) to Y=0 (final state)
        opacity: 1,
    }, 0); // Start at time 0 of the timeline

    // 2. Details Element Animation: Animate X back to 0 (its natural position)
    loadTimeline.to(productDetails, {
        x: 0, // Moves from X=50 (CSS) to X=0 (final state)
        opacity: 1,
    }, 0);
};
// ----------------------------------------------------


const animateHeroEntrance = () => {
    // ... [Your existing animateHeroEntrance code] ...
    const gsap = window.gsap;
    if (!gsap) return;

    const mainContainer = document.querySelector(".hero-carousel");
    if (!mainContainer) return;

    // Targets
    const activeSlide = mainContainer.querySelector(
      ".carousel-slide.is-active"
    );
    const mainImageMedia = activeSlide
      ? activeSlide.querySelector(".slide-media")
      : null;
    const popInImages = mainContainer.querySelectorAll(".pop-in-image");
    const slideContent = activeSlide
      ? activeSlide.querySelector(".slide-content")
      : null;

    if (!mainImageMedia || popInImages.length === 0) return;

    const tl = gsap.timeline({ paused: true, delay: 0.5 });

    // ------------------------------------
    // STAGE 1: POP-IN EFFECT SETUP
    // ------------------------------------
    // Set initial state for pop-in images (small, invisible, random start offset)
    gsap.set(popInImages, {
      scale: 1,
      opacity: 0,
    });

    // ------------------------------------
    // STAGE 2: ANIMATION SEQUENCE
    // ------------------------------------

    // 1. Pop-in animation for the decorative images (staggered)
    tl.to(
      popInImages,
      {
        opacity: 1,
        scale: 1,
        duration: 0.9,
        ease: "back.out(1.7)",
        stagger: 0.08,
      },
      0
    );

    tl.fromTo(
      mainImageMedia,
      {
        // 🔴 CORRECTED FROM STATE: Small, centered, and rounded
        width: "350px",
        height: "250px",
        borderRadius: 24,
        opacity: 1,
        position: "absolute",
        // ⬅️ CRITICAL FIX: Add starting position and centering offsets
        top: "50%", // Start position at vertical center of parent
        left: "50%", // Start position at horizontal center of parent
        xPercent: -50, // Adjust 50% left to center the element
        yPercent: -50, // Adjust 50% up to center the element
        transform: "none",
      },
      {
        // 🟢 TO STATE: Full size, top-left, square corners
        width: "100%",
        height: "100%",
        borderRadius: 0,
        duration: 1.5,
        ease: "power3.inOut",
      },
      0.5
    );

    // 3. Disappearance of the decorative images
    tl.to(
      popInImages,
      {
        opacity: 0,
        scale: 0.8,
        duration: 0.4,
        stagger: { amount: 0.2, from: "random" }, // Disappear in random order
        ease: "power1.in",
      },
      0.9
    ); // Start slightly before expansion finishes

    // 4. Fade in the text content
    if (slideContent) {
      tl.fromTo(
        slideContent,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 0.8,
          ease: "power1.out",
        },
        1.5
      );
    }

    tl.play();
  };


  document.addEventListener("DOMContentLoaded", () => {

    const headerContainer = document.querySelector("#site-header");

      gsap.to(
      headerContainer,
      {
        y: 0,
        opacity: 1,
        ease: "spring(0.5, 0.6, 1, 0)",
        duration: 1,
        delay: window.location.pathname === "/" ? 1.2 : 0.3
      },
      1
    );
    });


  document.addEventListener("DOMContentLoaded", () => {

    // Media animation (slide up + fade in)
    gsap.to(".product-information__media",
      { y: 0, opacity: 1, duration: 0.5, ease: "spring(0.5, 0.6, 1, 0)", }
    );

    // Details animation (slide from right + fade in)
    gsap.to(".product-details",
      { x: 0, opacity: 1, duration: 0.5, ease: "spring(0.5, 0.6, 1, 0)", }
    );

  });



document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  function initStoryHero() {

    // Kill existing triggers if re-initialized
    ScrollTrigger.getAll().forEach(st => {
      if (st.trigger?.classList?.contains("story-hero__heading")) {
        st.kill();
      }
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".story-hero__heading",
        start: "center center-=70",
        end: "+=800",
        scrub: true,
        pin: ".story-hero",
        pinSpacing: true,
        anticipatePin: 1,
        invalidateOnRefresh: true   // 👈 CRITICAL
      }
    });

    /* 1️⃣ Background */
    tl.to(".story-hero-bg", {
      width: "95%",
      height: "95%",
      opacity: 1,
      ease: "power2.out",
      duration: 1
    });

    /* 2️⃣ Floating images */
    tl.to(".story-hero__floating-image--1", {
      top: 80,
      opacity: 1,
      duration: 0.6,
      ease: "power2.out"
    }, ">+0.1")
    .to(".story-hero__floating-image--2", {
      top: 80,
      opacity: 1,
      duration: 0.6,
      ease: "power2.out"
    }, "<")
    .to(".story-hero__floating-image--3", {
      bottom: 80,
      opacity: 1,
      duration: 0.6,
      ease: "power2.out"
    }, "<")
    .to(".story-hero__floating-image--4", {
      bottom: 80,
      opacity: 1,
      duration: 0.6,
      ease: "power2.out"
    }, "<");

    // 🔁 Hard refresh after creation
    ScrollTrigger.refresh(true);
  }

  /**
   * 🧠 WAIT FOR PAGE TO ACTUALLY STABILIZE
   * Shopify products + images + sections
   */
  window.addEventListener("load", () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initStoryHero();
      });
    });
  });

  /**
   * 🔄 If Shopify loads sections dynamically
   */
  document.addEventListener("shopify:section:load", () => {
    setTimeout(initStoryHero, 2000);
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   // Split H1 into letters (no SplitText plugin)
//   const heading = document.querySelector(".sh-hero-left h1");
//   const text = heading.textContent;
//   heading.textContent = "";

//   text.split("").forEach(char => {
//     const span = document.createElement("span");
//     span.textContent = char === " " ? "\u00A0" : char;
//     heading.appendChild(span);
//   });

//   // GSAP timeline
//   const tl = gsap.timeline({ defaults: { ease: "power2.out" } });

//   // H1 letters animation
//   tl.fromTo(
//     ".sh-hero-left h1 span",
//     { scale: 1.5, opacity: 0 },
//     {
//       scale: 1,
//       opacity: 1,
//       duration: 1
//     }
//   );

//   // Paragraph animation
//   tl.fromTo(
//     ".sh-hero-left p",
//     { y: 20, opacity: 0 },
//     { y: 0, opacity: 1, duration: 0.6 },
//     "-=0.2" // overlaps slightly with heading
//   );
// });

document.addEventListener("DOMContentLoaded", () => {

  gsap.utils.toArray(".val-card").forEach(card => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: "top 90%",   // card enters 30% into screen
        toggleActions: "play none none none"
      }
    });

    tl.to(card.querySelector(".val-card__icon"), {
      opacity: 1,
      y: 0,
      duration: 0.5,
      ease: "power2.out"
    })
    .to(card.querySelector("h3"), {
      opacity: 1,
      y: 0,
      duration: 0.5,
      ease: "power2.out"
    }, "-=0.3")
    .to(card.querySelector("p"), {
      opacity: 1,
      y: 0,
      duration: 0.5,
      ease: "power2.out"
    }, "-=0.3");
  });
});

document.addEventListener("DOMContentLoaded", () => {

  const fbHeaderTl = gsap.timeline({
    scrollTrigger: {
      trigger: ".fb-header",
      start: "top 70%",          // 30% into viewport
      toggleActions: "play none none none"
    }
  });

  fbHeaderTl
    .to(".fb-header h2", {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out"
    })
    .to(".fb-header p", {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power2.out"
    }, "-=0.3"); // slight overlap
});

document.addEventListener("DOMContentLoaded", () => {
  gsap.utils.toArray(".fb-collection").forEach(collection => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: collection,
        start: "top 80%",       // container enters screen
        end: "center center",   // container reaches middle
        scrub: true
      }
    });

    // Text animation
    tl.to(
      collection.querySelectorAll(".fb-collection-text h3, .fb-collection-desc"),
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        stagger: 0.1
      }
    );

    // Product images animation
    tl.to(
      collection.querySelectorAll(".fb-product-image img"),
      {
        scale: 1,
        duration: 1,
        ease: "power2.out",
        stagger: 0.1
      },
      "<" // start at same time as text
    );
  });
});

document.addEventListener("DOMContentLoaded", () => {

  gsap.utils.toArray(".ap-card").forEach(card => {
    const image = card.querySelector(".ap-card-image");

    gsap.fromTo(
      image,
      { scale: 1.2 },
      {
        scale: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: card,
          start: "top 80%",   // card enters viewport
          end: "top 40%",     // finishes before center
          scrub: true
        }
      }
    );
  });
});

document.addEventListener("DOMContentLoaded", () => {
 gsap.to(".three-steps__card", {
    x: 0,
    duration: 0.8,
   ease: "spring(0.5, 0.6, 1, 0)",
    stagger: 0.15,
    scrollTrigger: {
      trigger: ".three-steps__cards",
      start: "top 70%", // 30% into viewport
      toggleActions: "play none none none"
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
    gsap.to(".orbital-container", {
    "--orbit-rotation": "30deg",
    ease: "none",
    scrollTrigger: {
      trigger: ".orbital-hero-section",
      start: "top center",
      end: "bottom center",
      scrub: true
    }
  });
});


// --- Execution Flow: Ensure everything runs only when layout is stable ---

document.addEventListener("DOMContentLoaded", () => {
    // Run the main scroll animations setup
    setupAnimations();
    
    // 🔴 NEW: Run the product detail animation explicitly after DOM content is fully parsed
    animateProductDetails();
    
    console.log("Animation setup complete.");
});


// Force full re-measure once everything is loaded (images/fonts)
window.addEventListener("load", () => {
    // 1. Initial refresh after all content is loaded
    ScrollTrigger.refresh();

    // 2. A final, crucial refresh after a small delay. This accounts for
    // any delayed loading of Shopify-specific assets (like fonts or dynamic heights).
    setTimeout(() => ScrollTrigger.refresh(), 300);
});